// const api="http://192.168.1.15/~ernesto/FunFarallones/2022/empleadosAPI/grb_empleados.php";
const api="https://www.fundacionclubfarallones.org/encuestas/empleadosAPI/grb_empleados.php";
export default api;